import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

export const selectorIsRequirementArchived = (
  requirement: PayeeRequirement
) => {
  return (
    !requirement.payeeEngagementIds ||
    requirement.payeeEngagementIds.length === 0
  );
};
